// US date/time formatting helpers.

/** "2026-06-24" -> "06/24/2026". Empty/invalid → "" */
export function fmtDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  if (!y || !m || !d) return iso;
  return `${m}/${d}/${y}`;
}

/** "14:30" -> "2:30 PM". Empty → "" */
export function fmtTime(t) {
  if (!t) return "";
  const [hStr, mStr] = t.split(":");
  const h = parseInt(hStr, 10);
  if (Number.isNaN(h)) return t;
  const suffix = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${(mStr || "00").padStart(2, "0")} ${suffix}`;
}

export function fmtDateTime(iso, t) {
  const d = fmtDate(iso);
  const tt = fmtTime(t);
  if (d && tt) return `${d} · ${tt}`;
  return d || tt || "";
}

export function fmtMoney(n) {
  const v = Number(n) || 0;
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
